<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template v-slot:actions>
                <rkm-button
                    :disabled="loading"
                    @click="handleExit"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="authorize('administracao-envio-sms-store')"
                    :disabled="loading"
                    @click="$refs.Form.save()"
                    color="success"
                >
                    Enviar
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <Form
                    :id="id"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import Form from '@/components/administracao/envio-sms/Form'

// Mixins.
import {authorization, notification} from '@/mixins'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('administracao-envio-sms-form')
        },
    },
    methods: {
        handleSave(data) {
            if (data.sent > 0 || data.unsent > 0) {
                if (data.unsent > 0) {
                    this.showWarningNotification('Atenção', `${data.sent} SMS enviado(s) com sucesso e ${data.unsent} SMS não enviado(s).`)
                } else {
                    this.showSuccessNotification('Sucesso', `${data.sent} SMS enviado(s) com sucesso.`)
                }

                this.handleExit(false)
            } else {
                this.showWarningNotification('Atenção', 'SMS não enviado. Não hà cidadão(s) com inconsistência de acordo com os critérios selecionados')
            }
        },
        handleExit(notification) {
            this.$router.push({name: 'administracao-envio-sms-index', params: {notification: notification}})
        },
    },
    mixins: [authorization, notification],
    props: {
        id: {type: Number},
    },
}
</script>